module.exports = __webpack_public_path__ + "img/nullnetwork.d1c282c1.jpg";